<template>
  <div>
    <form @submit.prevent="onSubmit">
        <div class="form-group">
          <textarea class="form-control" v-model="note" required></textarea>
        </div>

        <div class="mb-3">
          <users-select v-model="users" multiple exclude-self placeholder="Välj användare för att skicka notis"></users-select>
        </div>

        <button type="submit" class="btn btn-primary btn-sm">Spara</button>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, toRefs } from "vue";
const props = defineProps({
  quoteId: {
    type: Number,
    required: true
  }
});
const {
  quoteId
} = toRefs(props);
const emit = defineEmits(["note-added"]);
const note = ref(null);
const users = ref(null);
async function onSubmit() {
  const {
    data: newNote
  } = await axios.post(route('quote.notes.store', quoteId.value), {
    note: note.value,
    users_to_notify: users.value
  });
  emit('note-added', newNote);
  note.value = null;
  users.value = null;
}
</script>
